import { Form } from 'react-final-form';

import { useTranslation } from 'react-i18next';

import ModalFormPage from '../../../../../../../styledComponents/ModalFormPage/ModalFormPage';
import WarningsConfirmationModal from '../../../../../../../styledComponents/WarningsConfirmation/WarningsConfirmationModal/WarningsConfirmationModal';

import { withErrorProvider } from '../../../../../../../hoc/withErrorProvider';
import { withWarningsConfirmationProvider } from '../../../../../../../hoc/withWarningsConfirmationProvider';
import { SmallModal } from '../../../../../../../styledComponents/ModalCommon/ModalCommon';
import { useTLSubscriptionEditDetailsModal } from './tlSubscriptionEditOptionsModal.hooks';
import { EDIT_TL_SUBSCRIPTION_OPTIONS_MODAL_NAME } from './tlSubscriptionEditOptionsModal.const';
import { StyledSubscriptionOptions } from './tlSubscriptionEditOptionsModal.styles';
import { TLSubscriptionOptions } from '../../../../../../../styledComponents/Forms/SubscriptionOptions/subscriptionOptions.utils';

interface ITLSubscriptionEditDetailsModalProps {
  onModalSuccess: () => void;
}

const TLSubscriptionEditOptionsModal = ({
  onModalSuccess,
}: ITLSubscriptionEditDetailsModalProps) => {
  const { t } = useTranslation();

  const {
    handleWarningsConfirm,
    handleSubmit,
    subscriptionEditing,
    initData,
    onCancelHandler,
  } = useTLSubscriptionEditDetailsModal({ onModalSuccess });

  return (
    <>
      <WarningsConfirmationModal onWarningsConfirm={handleWarningsConfirm} />
      <SmallModal name={EDIT_TL_SUBSCRIPTION_OPTIONS_MODAL_NAME}>
        <Form
          initialValues={initData}
          keepDirtyOnReinitialize
          onSubmit={handleSubmit}
        >
          {({ ...renderProps }) => (
            <ModalFormPage
              handleSubmit={renderProps.handleSubmit}
              isProcessing={subscriptionEditing}
              onCancel={onCancelHandler}
              mode="small"
              title={t('headers.edit-options')}
            >
              <StyledSubscriptionOptions
                layout="column"
                disabled={subscriptionEditing}
                subscriptionOptions={TLSubscriptionOptions}
              />
            </ModalFormPage>
          )}
        </Form>
      </SmallModal>
    </>
  );
};

export default withErrorProvider(
  withWarningsConfirmationProvider(TLSubscriptionEditOptionsModal),
);
